<template>
  <div>
    <div class="flex flex-row">
      <div class="mr-2">
        <input
          v-model="searchField"
          type="text"
          class="input min-w-0 rounded px-4"
          :placeholder="$t('Search users')"
          @keydown="
            (e) => {
              if (e.key === 'Enter') search();
            }
          "
        />
      </div>
      <button @click="search" class="button button--primary px-5 rounded">
        <span>{{ $t('Search') }}</span>
      </button>
    </div>
    <transition name="fade">
      <div class="mt-10 overflow-x-auto" v-if="searchResults.length > 0">
        <p class="font-semibold text-xl leading-6 text-neutral-800 mb-2">
          {{ $t('Search results') }}
        </p>
        <table class="table-auto w-full mt-4">
          <thead>
            <tr>
              <th
                v-for="col in columns"
                :key="col.id"
                class="px-4 py-2 text-left"
              >
                {{ col.label }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="customer in searchResults"
              :key="customer.id"
              class="hover:bg-neutral-100 transition-colors duration-150 ease-in-out"
            >
              <td v-for="col in columns" :key="col.id" class="border px-4 py-2">
                <a v-if="col.prop === 'name'" :href="'/users/' + encodeURIComponent(customer.handle)">{{ customer.name }}</a>
                <template v-else>{{ customer[col.prop] }}</template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </transition>
    <p v-if="showNoResultsMessage" class="text--center text--lighter my-3">
      {{ $t('No results found') }}
    </p>
  </div>
</template>

<script>
export default {
  props: ["customers"],
  data: function () {
    return {
      columns: [
        { id: 1, prop: "name", label: this.$t("Name") },
        { id: 2, prop: "upvotes_received", label: this.$t("Upvotes received") },
        { id: 3, prop: "upvotes_given", label: this.$t("Upvotes given") },
        { id: 4, prop: "comments_count", label: this.$t("Comments count") },
      ],
      results: [],
      searchField: "",
      showNoResultsMessage: false,
    };
  },
  methods: {
    search() {
      if (this.searchField.length > 0) {
        var query = new RegExp(this.searchField, "i");
        this.results = this.customers.filter(
          (c) => c.name.match(query) || c.email.match(query)
        );
        this.showNoResultsMessage = !!!this.results.length;
      }
    },
  },
  computed: {
    searchResults() {
      return this.results;
    },
  },
  watch: {
    searchField(val) {
      if (val.length == 0) {
        this.results = [];
        this.showNoResultsMessage = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
